export const OIDC_SESSION_SIGNAL_CHANNEL = 'auth:oidc-session' as const;
export const OIDC_SESSION_SIGNAL_TYPE = 'logout' as const;

export const OIDC_SESSION_REVOKED = 'OIDC_SESSION_REVOKED' as const;
export const OIDC_SESSION_KEY_MISSING = 'OIDC_SESSION_KEY_MISSING' as const;

export type OidcSessionLogoutSignal = {
  type: typeof OIDC_SESSION_SIGNAL_TYPE;
  sessionKey: string;
};

export function createOidcSessionLogoutSignal(
  sessionKey: string,
): OidcSessionLogoutSignal {
  return {
    type: OIDC_SESSION_SIGNAL_TYPE,
    sessionKey,
  };
}

export function isOidcSessionLogoutSignal(
  message: unknown,
): message is OidcSessionLogoutSignal {
  if (!message || typeof message !== 'object') {
    return false;
  }

  return (
    'type' in message &&
    message.type === OIDC_SESSION_SIGNAL_TYPE &&
    'sessionKey' in message &&
    typeof message.sessionKey === 'string' &&
    message.sessionKey.length > 0
  );
}
